<template>
  <Modal
    @closeModal="handleCerrar"
    :showMovilHeader="true"
    :fit="true"
    :showHeader="false"
    :linea="false"
  >
    <div class="body-container">
      <img src="@/assets/imgs/icons/icono-exito.svg" />
      <p class="title">{{ mensaje }}</p>

      <div class="btn-container">
        <button class="btn-aceptar" @click="handleCerrar">Aceptar</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Modales/Modal.vue";
export default {
  components: {
    Modal,
  },
  emits: ["cerrar"],
  props: {
    mensaje: {
      type: String,
      default: "El estatus de la cita ha sido cambiada con éxito.",
    },
  },
  methods: {
    handleCerrar() {
      this.$emit("cerrar");
    },
    editarStatus() {
      this.$emit("editar", { status: this.status?.status, id: this.status.id });
    },
  },
  computed: {
    getStatus() {
      switch (this.status?.status) {
        case 0:
          return "cancelar";
        case 1:
          return "pendiente";
        case 2:
          return "no asistio";
        case 3:
          return "asistio";
        default:
          return "pendiente";
      }
    },
  },
};
</script>

<style scoped>
.body-container {
    width: 541px;
    height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;

}
img {
  widows: 80px;
  height: 95px;
}
.title {
    margin-top: 15px;
  width: 100%;
  text-align: center;
  font: normal normal bold 20px/27px Open Sans;
  letter-spacing: 0px;
  color: #0A4F9C;
}


.btn-container {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-aceptar {
  width: 172px;
  height: 40px;
  background: #4caf50 0% 0% no-repeat padding-box;
  border-radius: 4px;
  color: #fff;
}

@media screen and (max-width: 767px) {
  .title {
    font: normal normal bold 14px/19px Open Sans;
  }
  .body-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 350px;
    width: 100%;
    padding: 20px;
    height: 100vh;
  }
}
</style>
